export function createDownloadAttachmentLink(filename: string, content: any) {
    if(!filename || !content) {
        return;
    }

    const a = document.createElement('a');
    a.href = content;
    a.download = filename;
    a.click();
}